import { app } from '../../../../../app';
import { Controller } from './upgrade-license-tier.controller';

app.component('upgradeLicenseTier', {
    bindings:{
        licenseDetails: '<',
        licenseTiers: '<',
    },
    controller: Controller,
    templateUrl: require('./upgrade-license-tier.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/upgrade/tier/upgrade-license-tier.component.js